import { useEffect, useState } from "react";
import { loginRequest } from "../authConfig";
import { msalInstance } from "../index";
import config from "../config.json";


const acquireAccessToken = async () => {
    const enableMSAL = !!config.MSAL?.auth?.clientId;

    if (!enableMSAL) {
        return;
    }

    const account = msalInstance.getActiveAccount();
    if (!account) {
        return;
    }

    try {
        const authResult = await msalInstance.acquireTokenSilent({
            ...loginRequest,
            account: account
        });
        return authResult.accessToken;
    } catch (error) {
        msalInstance.clearCache();
        const authResult = await msalInstance.acquireTokenPopup(loginRequest);
        return authResult.accessToken;
        }
    }


const useAccessToken = () => {
    const [accessToken, setAccessToken] = useState(null);

    useEffect(() => {
        const _acquireAccessToken = async () => {
            const accessToken = await acquireAccessToken();
            setAccessToken(accessToken);
        }
        _acquireAccessToken();
    }, []);

    return { accessToken };
}

export default useAccessToken;